import { isBRServer } from '@/utils/Validators/validation';

export const PROVIDERS = {
  REGISTROBR: 'registrobr',
  GODADDY: 'godaddy',
  LOCAWEB: 'locaweb',
  UOL_HOST: 'uol_host',
  WEB_EMPRESA: 'web_empresa',
  COLOMBIA_HOSTING: 'colombia_hosting',
  NEUBOX: 'neubox',
  OTHERS: 'others',
};

const brOptions = ['registrobr', 'godaddy', 'locaweb', 'uol_host', 'others'];
const esOptions = ['godaddy', 'web_empresa', 'colombia_hosting', 'neubox', 'others'];

export const optionsList = isBRServer ? brOptions : esOptions;
